import { useSelector } from 'react-redux';
import { getRevisionData } from '../ducks';

export const useGetRevisionData = () => {
  const revisionData = useSelector(getRevisionData);
  return { ...revisionData };
};
